module.exports = __webpack_public_path__ + "img/timeline-profile-container.d84dcc38.svg";